module.exports = __webpack_public_path__ + "static/img/school4.71030a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/school4.png
// module id = 4cQy
// module chunks = 1